import { render, staticRenderFns } from "./FollowedUsersSetting.vue?vue&type=template&id=0174900d&"
import script from "./FollowedUsersSetting.vue?vue&type=script&lang=js&"
export * from "./FollowedUsersSetting.vue?vue&type=script&lang=js&"
import style0 from "./FollowedUsersSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports